export default __webpack_public_path__ + "static/media/benefit2.f3459fb0.svg";